import { Injectable } from '@angular/core';
import { PolicyDetail } from '@shared/models/policy-detail';
import { Policy } from '@shared/models/policy';

import policiesMock from '@mocks/getPoliciesB2B.json';

import policyDetailMock from '@mocks/getPolicyDetailB2B.json';

import terminationTypes from '@mocks/terminationTypes.json';

import documentsMock from '@mocks/getDocuments.json';
import { CommonService } from './common.service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Premium } from '@shared/models/premium';
import { last, map } from 'rxjs/operators';
import { DataService } from './data.service';
import { PaymentStatus } from '@shared/models/payment-status';
import { Correspondence } from '@shared/models/correspondence';
import { TranslateService } from '@ngx-translate/core';
import { DownloadAllStatus } from '@shared/models/download-all-status';
import { MaInsuranceUpdate } from '@shared/models/ma-insurance-update';
import { UserRole } from '@shared/models/codebooks/user-role';
import { TerminationType } from 'app/models/policy/detail/cancel-policy/TerminationType';
import { CheckVinRequest } from 'app/models/policy/detail/cancel-policy/check-vin/CheckVinRequest';
import { CheckVinResponse } from 'app/models/policy/detail/cancel-policy/check-vin/CheckVinResponse';
import { AddressResponse } from 'app/models/policy/detail/cancel-policy/AddressResponse';
import { TerminationRequest } from 'app/models/policy/detail/cancel-policy/termination/TerminationRequest';
import { TerminationResponse } from 'app/models/policy/detail/cancel-policy/termination/TerminationResponse';
import { InsuredTripTravelCardRequestMultiple } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-request-multiple';
import { InsuredTripTravelCardResponse } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-response';
import { GreenCardRequest } from '@shared/models/policies/detail/green-card-request';
import { GreenCardResponse } from '@shared/models/policies/detail/green-card-response';

@Injectable({
    providedIn: 'root'
})
export class PolicyService {
    private policices: Policy[];
    private policyDetail: PolicyDetail;
    private documents: Correspondence[];
    // private activePremiumList: Premium[];
    // private pastPremiumList: Premium[];
    // public Policies: Observable<Policy[]>;
    private activePremiumList: Premium[];
    private pastPremiumList: Premium[];
    // public Policies: Observable<Policy[]>;

    private terminationTypes: object;

    readonly paymentStatus: typeof PaymentStatus = PaymentStatus;

    constructor(
        private translateService: TranslateService,
        public commonService: CommonService,
        private dataService: DataService,
        private http: HttpClient) {
        this.policices = policiesMock;
        this.policyDetail = policyDetailMock;
        this.terminationTypes = terminationTypes;

        this.documents = documentsMock;
    }

    public getAllPolicies(): Observable<Policy[]> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.policices))
                .pipe(map(this.mapPolicy));
        }

        return this.http.get<Policy[]>(this.commonService.getServiceUrl('policy'))
            .pipe(map(this.mapPolicy));
    }

    public getActivePolicies(): Observable<Policy[]> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.policices))
                .pipe(map(this.mapPolicy, this));
        }

        return this.http.get<Policy[]>(this.commonService.getServiceUrl('policy/active'))
            .pipe(map(this.mapPolicy, this));
    }

    public getInactivePolicies(): Observable<Policy[]> {

        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.policices))
                .pipe(map(this.mapPolicy, this));
        }

        return this.http.get<Policy[]>(this.commonService.getServiceUrl('policy/inactive'))
            .pipe(map(this.mapPolicy, this));
    }

    public getPolicyDetail(state: string, policyNumber: string): Observable<PolicyDetail> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.policyDetail))
                .pipe(map(this.mapPolicyDetail, this));
        }

        return this.http.get<PolicyDetail>(this.commonService.getServiceUrl(`policy/detail/${state}/${policyNumber}`))
            .pipe(map(this.mapPolicyDetail, this));
    }

    public setMaInsurance(maInsuranceUpdate: MaInsuranceUpdate): Observable<MaInsuranceUpdate> {
        return this.http.post<MaInsuranceUpdate>(this.commonService.getServiceUrl('change'), {
            action: 'updateVehicle',
            data: maInsuranceUpdate
        });
    }


    public getTerminationTypes(type: string, policyNumber: string): Observable<TerminationType[]> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.terminationTypes))
                .pipe(map(this.mapTerminationTypes, this));
        }

        return this.http.get<TerminationType[]>(this.commonService.getServiceUrl(`terminationType/${type}/${policyNumber}`))
            .pipe(map(this.mapTerminationTypes, this));
    }

    public checkVin(checkVinRequest: CheckVinRequest): Observable<CheckVinResponse[]> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next([
                {
                    lobId: 3,
                    policyNumber: '6690076424',
                    productNameSpecific: 'Poistenie auta',
                    paymentBlockageFlag: true
                } as CheckVinResponse,
                {
                    lobId: 8,
                    policyNumber: '6690076425',
                    productNameSpecific: 'Poistenie auta',
                    paymentBlockageFlag: false
                } as CheckVinResponse
            ]));
        }

        return this.http.post<CheckVinResponse[]>(this.commonService.getServiceUrl('check-vin'), checkVinRequest);
    }

    public getUserAddress(): Observable<AddressResponse> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(
                {
                    street: "Wolkrova",
                    registrationNumber: null,
                    descriptiveNumber: "27",
                    city: "Bratislava",
                    zip: "85101",
                    state: "SK"
                } as AddressResponse
            ));
        }
        return this.http.get<AddressResponse>(this.commonService.getServiceUrl('address'));
    }

    public cancelPolicy(terminationRequest: TerminationRequest): Observable<TerminationResponse> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(
                {
                    "xmlFiles": ["D:\\onlinetest.allianz.sk\\moj-allianz-api\\app\\config\/..\/..\/..\/..\/AZK_MT_PP_CANCEL_XML\/\\AK00000001.xml"]
                } as TerminationResponse
            ));
        }

        return this.http.post<TerminationResponse>(this.commonService.getServiceUrl('generateXml'), terminationRequest);
    }

    public checkPolicyExistence() {
        return this.http.get(this.commonService.getServiceUrl('policy/check-existence'));
    }

    private mapTerminationTypes(terminationTypeObject: object) {
        let terminationTypes: TerminationType[] = [];

        Object.keys(terminationTypeObject).forEach(terminationTypeObjectKey => {
            terminationTypes.push({
                code: terminationTypeObjectKey,
                label: terminationTypeObject[terminationTypeObjectKey]
            } as TerminationType);
        });

        return terminationTypes;
    }

    private mapPolicyDetail(policyDetail: PolicyDetail): PolicyDetail {
        if (this.commonService.getLoggedUser().role == UserRole.LegalPerson
            && policyDetail.policy.policyNumber.startsWith('669')) {
            policyDetail.policy.productNameSpecific = 'Rámcová zmluva';
        }

        policyDetail.policy.groupIcon = this.dataService.activeInsuranceGroups
            .find(group => group.lobIds.some(x => x === policyDetail.policy.lineOfBusinessId)).icon;
        policyDetail.policy.groupName = this.dataService.activeInsuranceGroups
            .find(group => group.lobIds.some(x => x === policyDetail.policy.lineOfBusinessId)).name;
        policyDetail.policy.policyState =
            this.dataService.policyStates.active.statusIdList.some(statusId => statusId === policyDetail.policy.statusId) ?
                this.dataService.policyStates.active : this.dataService.policyStates.past;
        policyDetail.policy.canBePayed = policyDetail.policy.premiumStatus !== PaymentStatus.paid && policyDetail.policy.paymentMethodId !== 2;

        const canFileAClaimDate = new Date();
        canFileAClaimDate.setFullYear(canFileAClaimDate.getFullYear() - 3);
        policyDetail.policy.canFileAClaim = !policyDetail.policy.endDate || new Date(policyDetail.policy.endDate).getTime() >= canFileAClaimDate.getTime();

        policyDetail.premiumList.list.forEach(x => {

            // set premium status (overdue, paid, unpaid)
            // will be send from WS
            /*x.paymentStatus = !!x.matchDate ? this.paymentStatus.paid
              : new Date(x.maturityDate) < new Date() ? this.paymentStatus.overdue : this.paymentStatus.unpaid;*/
            if (typeof x.paymentStatus != 'undefined') {
                x.canBePayed = x.paymentStatus !== PaymentStatus.paid && policyDetail.policy.paymentMethodId !== 2;
            } else {
                x.canBePayed = x.status !== PaymentStatus.paid && policyDetail.policy.paymentMethodId !== 2;
            }

        });


        if (policyDetail.policy.downloadAllStatus == null) {
            policyDetail.policy.downloadAllStatus = new DownloadAllStatus();
        }

        return policyDetail;
    }

    private mapPolicy(policyList: Policy[]): Policy[] {
        const canFileAClaimDate = new Date();
        canFileAClaimDate.setFullYear(canFileAClaimDate.getFullYear() - 3);
        policyList.forEach(policy => {
            // policy.groupIcon = this.dataService.activeInsuranceGroups
            // .find(group => group.lobIds.some(x => x === policy.lineOfBusinessId)).icon;
            // policy.groupName = this.dataService.activeInsuranceGroups
            //   .find(group => group.lobIds.some(x => x === policy.lineOfBusinessId)).name;
            // we don't have codebook for paymentMethod so id is used

            if (this.commonService.getLoggedUser().role == UserRole.LegalPerson
                && policy.policyNumber.startsWith('669')) {
                policy.productNameSpecific = 'Rámcová zmluva';
            }

            policy.policyState =
                this.dataService.policyStates.active.statusIdList.some(statusId => statusId === policy.statusId) ?
                    this.dataService.policyStates.active : this.dataService.policyStates.past;
            policy.canBePayed = policy.premiumStatus !== PaymentStatus.paid && policy.paymentMethodId !== 2;
            policy.canFileAClaim = !policy.endDate || new Date(policy.endDate).getTime() >= canFileAClaimDate.getTime();
            policy.downloadAllStatus = new DownloadAllStatus();
        }, this);
        return policyList;
    }

    public getDocuments(policyNumber: string): Observable<Correspondence[]> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.documents));
        }

        return this.http.get<Correspondence[]>(this.commonService.getServiceUrl(`correspondence/list/${encodeURIComponent(policyNumber)}`));
    }

    public generateTravelCard(insuredTripTravelCardRequest: InsuredTripTravelCardRequestMultiple): Observable<InsuredTripTravelCardResponse> {
        return this.http.post<InsuredTripTravelCardResponse>(this.commonService.getServiceUrl('generatePdf'), insuredTripTravelCardRequest);
    }

    public generateGreenCard(insuredTripTravelCardRequest: GreenCardRequest): Observable<GreenCardResponse> {
        return this.http.post<GreenCardResponse>(this.commonService.getServiceUrl('generatePdf'), insuredTripTravelCardRequest);
    }

    public getGreenCard(uuid: string) {
        window.open(this.commonService.getServiceUrl(`generatePdf/${uuid}`), '_blank');
    }
}